// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-contribution-form-form-components-text-box----styles-module---container---1OUDZ","required":"src-components-contribution-form-form-components-text-box----styles-module---required---QzRMl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contribution-form/form-components/text-box/styles.module.css
// module id = 624
// module chunks = 168707334958949